// extracted by mini-css-extract-plugin
export var loadingSpinner = "_28-0";